module.exports = __webpack_public_path__ + "static/media/va.90e9f73a.svg";